/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-15 14:37:23
 * @LastEditors: changfeng
 * @LastEditTime: 2024-08-30 14:33:20
 */
import { useLocation, Navigate } from "react-router-dom";
import { AxiosCanceler } from "@/api/helper/axiosCancel";
import { searchRoute } from "@/utils/util";
import { rootRouter } from "@/routers/index";
import { HOME_URL } from "@/config/config";
import { store } from "@/redux/index";

const axiosCanceler = new AxiosCanceler();

/**
 * @description 路由守卫组件
 * */
const AuthRouter = (props: { children: JSX.Element }) => {
	const { pathname } = useLocation();
	const route = searchRoute(pathname, rootRouter);
	// * 在跳转路由之前，清除所有的请求
	axiosCanceler.removeAllPending();

	// * 判断当前路由是否需要访问权限(不需要权限直接放行)
	if (!route.meta?.requiresAuth) {
		return props.children;
	}



	// * 判断是否有Token
	const token = localStorage.getItem("token");

	if (!token) return <Navigate to="/login" replace />;

	return props.children;
};

export default AuthRouter;
